<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-8 text-center text-navy mb-3">
        The below individuals will be sent a link for ID verification. Please
        ensure everyone who is legally required to sign on behalf of
        <strong>{{ initial_lead.name || "your business" }}</strong> are shown
        below. If not please return to the contacts page to make adjustments.
      </div>
      <div class="col-8 text-navy mb-4">
        <div class="row">
          <div
            class="col-12 text-grey fa-sm text-center"
            v-if="
              guarantors.filter((c) => c.email && c.is_signatory).length == 0
            "
          >
            There is not contacts for ID verification
          </div>
          <div v-else class="col-12 col-lg-12">
            <div class="row">
              <div class="col-4 font-weight-bold">First Name</div>
              <div class="col-4 font-weight-bold">Last Name</div>
              <div class="col-4 font-weight-bold">Email</div>
              <div class="col-12">
                <hr class="my-2" />
              </div>
            </div>
          </div>
          <div
            class="col-12 col-lg-12"
            v-for="(guarantor, index) in guarantors.filter(
              (c) => c.email && c.is_signatory
            )"
            :key="index"
          >
            <div class="row">
              <div class="col-4">
                {{ guarantor.first_name }}
              </div>
              <div class="col-4">
                {{ guarantor.last_name }}
              </div>
              <div class="col-4">
                {{ guarantor.email }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4 mt-4"></div>
    <div
      class="px-5 pb-4"
      style="position: absolute; bottom: 0; left: 0; right: 0"
    >
      <div class="d-flex justify-content-between">
        <el-button class="btn-secondary" @click="updateLead('prev')">
          Previous
        </el-button>
        <div>
          <el-button
            class="btn-secondary px-4"
            @click="updateLead('save')"
            v-if="onboardingAccount.is_completed == false"
          >
            Save Progress
          </el-button>
          <el-button class="btn-secondary" @click="updateLead('next')">
            Next
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initial_lead: {
      type: Object,
    },
    onboardingAccount: {
      type: Object,
    },
  },
  data() {
    return {
      guarantors: this.initial_lead.guarantors,
    };
  },
  methods: {
    updateLead(step) {
      let lead = this.initial_lead;
      lead.is_completed = true;
      lead.guarantors = this.guarantors;
      this.$emit("update-lead", lead, step);
    },
  },
};
</script>
